export const tableKeys = {
	DATA_PAGES: {
		ADVISOR_PERFORMANCE: "data-pages/advisor-performance",
		CALL_ACTIVITY: "data-pages/call-activity",
		CHARGE_BACKS: "data-pages/charge-backs",
		FNI_MANAGEMENT_ALL_DEALS: "data-pages/fni-management/all-deals",
		FNI_MANAGEMENT_CIT: "data-pages/fni-management/cit-data-table",
		FNI_MANAGEMENT_FI_DEAL: "data-pages/fni-management/f&i-data-table",
		FNI_MANAGEMENT_FI_DETAILS: "data-pages/fni-management/f&i-details-table",
		FNI_MANAGEMENT_FI_TRADES_PAYOFFS: "data-pages/fni-management/f&i-payoffs-table",
		FNI_MANAGEMENT_FI_TITLING: "data-pages/fni-management/f&i-titling-table",
		FNI_MANAGEMENT_FI_CANCELLATIONS: "data-pages/fni-management/f&i-cancellations-table",
		CUSTOMER_ENGAGEMENT_TRAIL: "data-pages/customer-engagement-trail",
		DEALER_INVENTORY: "data-pages/dealer-inventory",
		CONSUMER_REGISTRATION: "data-pages/consumer-registration",
		DRAWS_AND_OVERDRAWS: "data-pages/draws-and-overdraws",
		SALES_LOG: "data-pages/sales-log",
		SALES_PERFORMANCE: "data-pages/sales-performance",
		SOCIAL_MEDIA_REVIEWS: "data-pages/social-media-reviews/associates",
		TECHNICIAN_FLAGGED_TIME: "data-pages/technician-flagged-time",
		TIME_PAY_RATES_PTO: "data-pages/time-and-pay-rates/pto",
		TIME_PAY_RATES_TIME: "data-pages/time-and-pay-rates/time",
		TIME_PAY_RATES_WORK_HOURS: "data-pages/time-and-pay-rates/work-hours",
		USERS: "data-pages/users",
		REPAIR_ORDERS: "data-pages/service-operations/repair-orders",
	},
} as const;
